var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.backUrlName)?_c('div',{staticClass:"comp-bizcomp-dc-title comp"},[_c('div',{staticClass:"back-content",on:{"click":_vm.handleBack}},[_c('i',{staticClass:"el-icon-arrow-left",attrs:{"ria-hidden":"true"}}),_c('span',{staticClass:"back-text"},[_vm._v("返回")])]),_c('div',{staticClass:"slot"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }